import { COLOR_RANGE_LIST, ColorRange } from "@/modules/productivity-cockpit/types/ColorRanges"

export const ARCS_RADIUS = 252

export const buildBackground = (
  min: number,
  max: number,
  step: number,
  separatorRanges: number[],
  colorRanges: (ColorRange | string)[],
  value: number,
  arcDegree: number,
  startDegree: number,
  isHighlight?: boolean,
) => {
  let styleString = ""
  let stop = false
  let counter = 0
  let [color] = colorRanges

  separatorRanges.forEach((index) => {
    counter += step
    const internalColor = colorRanges[Math.trunc(index / 2)]
    const internalStartDegree = (index - min) * arcDegree
    const stopDegree = (index + 1 - min) * arcDegree
    const colorStyles = `${internalColor} ${internalStartDegree}deg, ${internalColor} ${stopDegree}deg,`

    // Default Color
    if (!isHighlight) styleString += colorStyles
    // Highlight Color
    else if (!stop) {
      if (value >= counter) styleString += colorStyles
      else {
        styleString += `${internalColor} ${internalStartDegree}deg, ${internalColor} ${stopDegree + startDegree}deg,`
        color = internalColor
        stop = true
      }
    }
  })

  if (value >= max) color = COLOR_RANGE_LIST.GREEN

  styleString += !isHighlight
    ? `transparent ${ARCS_RADIUS}deg, transparent`
    : `transparent ${((value - min) * arcDegree) / step}deg, transparent`

  return { background: `conic-gradient(from ${startDegree}deg, ${styleString})`, color }
}

export const buildDividerTransform = (index: number, arcDegree: number, startDegree: number) => {
  const xAxis = `calc(sin(${startDegree + index * arcDegree}deg) * var(--radius) - 50%)`
  const yAxis = `calc(cos(${startDegree + index * arcDegree}deg) * -1 * var(--radius))`
  const translate = `translate(${xAxis}, ${yAxis})`
  const rotate = `rotate(${startDegree + index * arcDegree}deg)`

  return `${translate} ${rotate}`
}
